import usePlayback from 'src/hooks/usePlayback';
import useUI from 'src/hooks/useUI';
import PlaybackRateControl from 'src/themes/cosmos/components/PlaybackRateControl';

const PlaybackRateControlContainer = () => {
  const { hideSettings } = useUI();
  const { playbackRate, setPlaybackRate, playbackRateOptions } = usePlayback();
  return (
    <PlaybackRateControl
      rateSelected={playbackRate}
      onChange={(rate) => {
        hideSettings();
        setPlaybackRate(rate);
      }}
      playbackRateOptions={playbackRateOptions}
    />
  );
};

export default PlaybackRateControlContainer;
